import {
  ChangeDetectionStrategy,
  Component,
  Input,
  inject,
} from '@angular/core';
import {
  ControlContainer,
  FormGroup,
  ReactiveFormsModule,
} from '@angular/forms';
import { momentToNgbDate } from '@core/utils/core.util';
import { NgbDatepickerModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';
import { ValidationErrorComponent } from '@shared/components/validation-error/validation-error.component';
import { InputValidationStatusDirective } from '@shared/directives/input-validation-status.directive';
import { RequirePermissionDirective } from '@shared/directives/require-permission.directive';
import { controlContainerProvider } from '@shared/helpers';
import moment from 'moment';

@Component({
  selector: 'app-service-data-form-patient-information',
  imports: [
    ReactiveFormsModule,
    TranslateModule,
    ValidationErrorComponent,
    NgbDatepickerModule,
    InputValidationStatusDirective,
    RequirePermissionDirective,
  ],
  templateUrl: './service-data-form-patient-information.component.html',
  viewProviders: [controlContainerProvider],
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ['./service-data-form-patient-information.component.scss'],
})
export class ServiceDataFormPatientInformationComponent {
  private controlContainer = inject(ControlContainer);

  @Input() id: string;

  protected minDate = moment().add(-100, 'year');
  protected maxDate = moment().subtract(5, 'year');
  protected birthdayStartDate = moment().subtract(25, 'year');
  protected readonly momentToNgbDate = momentToNgbDate;

  protected get form() {
    return this.controlContainer.control as FormGroup;
  }
}
